<template>
    <div></div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    name: "SetData",
    props: {
        company_settings: {
            required: true
        }
    },
    mounted() {
        this.ActionSetCompanySettings(this.company_settings)
    },
    methods: {
        ...mapActions("company", [
            "ActionSetCompanySettings"
        ])
    }
};
</script>
